<app-logo-area
  [breadcrumbs]="breadcrumbs"></app-logo-area>
<main>
  <app-headline-section [title]="'My organizations'">
    <button type="button" class="btn cl-color-sea" (click)="dismiss()"><span>To my work</span></button>
  </app-headline-section>
  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8"><p class="cl-p-large">Organizations that you're a member of are listed below.</p>
          <p class="alert cl-alert-info"> Only organizations you're assigned a <!----><span class="cl-role-dark">Content Platform</span>
            role are shown. </p></div>
      </div>
    </div>
  </section>
  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <table class="cl-table-data">
            <colgroup>
              <col class="cl-col-id" style="width: 50px">
              <col class="cl-col-legacy-name" style="width: 50%">
              <col class="cl-col-name" style="width: 50%">
              <col class="cl-col-actions" style="width: 50px">
            </colgroup>
            <thead>
            <tr>
              <th class="cl-p-tiny">ID</th>
              <th class="cl-p-tiny">Organization</th>
              <th class="cl-p-tiny">API Name</th>
              <th class="cl-p-tiny"></th>
            </tr>
            </thead>
            <tbody>
              @if (loading) {
                <tr class="cl-tr-no-data">
                  <td colspan="100" style="text-align: center">
                    <div class="cl-spinner">Loading Organizations ...<i class="fas fa-spinner fa-spin"></i>
                    </div>
                  </td>
                </tr>
              } @else {
                @for (oData of organizations; track oData.org.id) {
                  <tr>
                    <td class="cl-td-id vtk-col-id">{{ oData.org.id | orgResolver }}</td>
                    <td>
                <span class="cl-org">{{ oData.org.name }}
                  <a [routerLink]="oData.url" role="button" class="cl-a-transparent"></a>
                </span>
                    </td>
                    <td>
                <span class="cl-org">{{ oData.org.legacy_name }}
                  <a [routerLink]="oData.url" role="button" class="cl-a-transparent"></a>
                </span>
                    </td>
                    <td class="cl-td-links">
                      <a [routerLink]="oData.url" role="button" class="cl-a-btn">Switch</a>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</main>
